export const media = {
  mobile: `@media (min-width: 415px)`,
  mobileLandscape: `@media (min-width: 576px)`,
  pad: `@media (min-width: 768px)`,
  desktop: `@media (min-width: 1024px)`,
}
